// "render-url" returns the URL an HTML artifact renders from, rather than being that URL: it
// carries a ticket only the server can mint. See api/get-artifact-render-url.
type ArtifactUrlKind = "content" | "download" | "render-url"

interface ArtifactUrlParams {
  accountAlias: string
  threadId: string
  artifactId: string
}

export function buildArtifactUrl({ accountAlias, threadId, artifactId }: ArtifactUrlParams, kind: ArtifactUrlKind): string {
  return `/api/${encodeURIComponent(accountAlias)}/ai/chat/threads/${encodeURIComponent(threadId)}/artifacts/${encodeURIComponent(artifactId)}/${kind}`
}
